import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { cargarCatalogosGenericoAsync, cargarCatalogosAsync } from '../../funciones_globales/catalogos';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormVen07  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fechaDesde: null,
            fechaHasta: null,
            cliente_sel: null,
            zona_sel: null,
            vendedor_sel: null,
            opt_vendedor: [],
            resumido: false
        };
        this.impVendedoresZona = this.impVendedoresZona.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    getOptions_Zona(input, callback){
        if(input.toString().length >= 1)
        cargarCatalogosAsync('ZONACLIEN', input, callback)
    }

    getOptions_Clientes(input, callback){
        if (input.toString().length >= 3 ){
          let query = "?tipo=catalogo&cadena_busq=" + input;
          cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }

    getOptions_Vendedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/vendedores', cadena_busq, callback)              
        }
    }

    componentDidMount(){
        Promise.all([
            this.props.generar_LogAuditoriaIngresoForm('0407')
         ])
        .then(() => {

            //Asignacion de Fecha
            let fechaProceso = getFechaProcesoPorModulo('04')
            let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
            let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
            this.setState({fechaDesde: fechaDesde, fechaHasta:fechaHasta})

        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0407');
    }

    validacionFechaTrabajo(fechaProceso, fecha){
        
        var respuesta;
        var i_fecha = formatearFechaMoment_a_String(fecha)
        let fechaPartProceso = fechaProceso.split('/');
        let fechaPart = i_fecha.split('/');

        //Evaluacion Año
        if(fechaPart[2]===fechaPartProceso[2]){
            respuesta = true;
        }else{
            respuesta = false;
        }

        return respuesta;
    }

    impVendedoresZona(){
        var continuar = true;
        var error = "";
        var errorAnio = false;

        if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0 && errorAnio === false){
            continuar = false;
            error=error+'- La fecha desde debe ser menor a: '+formatearFechaMoment_a_String(this.state.fechaHasta)+'\n';
        }

        if(continuar === true){
            let parametros = "&rpt=" + (this.state.resumido===true?"16": "12");

            parametros += '&param1='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)+'&param2='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);

            if(this.state.zona_sel!==null){
                parametros += '&param3='+this.state.zona_sel.value
            }

            if(this.state.vendedor_sel!==null){
                parametros += '&param4='+this.state.vendedor_sel.value
            }

            if(this.state.cliente_sel!==null){
                parametros += '&param5='+this.state.cliente_sel.value
            }
            console.log('envio: ', parametros)
            visualizarReporteEnPdf(parametros);            
        }else{
            alert(error)
        }
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('04')

        let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
        let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
        this.setState({fechaDesde: fechaDesde, fechaHasta: fechaHasta})

        this.setState({
            cliente_sel: null, zona_sel: null, vendedor_sel: null, resumido: false
        });
    }

    render(){
        return (
            <ContenedorForm porc_ancho={90}>
            <HeaderForm>
                <TituloForm>Ventas Por Zona</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-md-4 col-md-ofset-8'>
                            <LabelForm>Vendedor:</LabelForm>
                            <ReactSelectAsync value={this.state.vendedor_sel} func_loadOptions={this.getOptions_Vendedores} func_onChange={(value)=>{this.setState({vendedor_sel: value})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Fecha Desde:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaEscogida)=>{this.setState({fechaDesde: fechaEscogida});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Fecha Hasta:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaEscogida)=>{this.setState({fechaHasta: fechaEscogida});}}/>
                        </ContainerCol>                        
                        <ContainerCol className='col-sm-3'>
                            <LabelForm>Zona:</LabelForm>
                            <ReactSelectAsync value={this.state.zona_sel} func_loadOptions={this.getOptions_Zona} func_onChange={(value)=>{this.setState({zona_sel: value})}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-3'>
                        <LabelForm>Cliente:</LabelForm>
                            <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} func_onChange={(value)=>{this.setState({cliente_sel: value})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2' margen_arriba={5}>
                            <LabelForm><input type='checkbox' name='resumido' checked={this.state.resumido} 
                                onChange={this.handleInputChange}/> Resumido</LabelForm>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.impVendedoresZona}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }

}

const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            fechaProceso: state.sesion.valoresSesionForm.FechaProceso,
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario
        }
  });
  
  const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
  });
  
  export default connect (mapStateToProps, mapDispatchToProps)(FormVen07);